import type { GridValidRowModel } from '@mui/x-data-grid-pro';
import type { CustomGridColDef } from '../services';
import { storeColMapper } from '../services/tableColumnRender/storeColMapper';
import type { SavedColDef } from '../store';
import { isPaddingColumn } from './columnFilters';
import { mergeColumnsWithStore } from './mergeColumnsWithStore';

export const syncColumnsWithStore = <T extends GridValidRowModel>(
  storeColumns: SavedColDef[] | null,
  defaultColumns: CustomGridColDef<T>[],
  isHydrated: boolean,
  hasAsyncStorage: boolean,
): SavedColDef[] | null => {
  if (isHydrated && (!storeColumns || storeColumns.length === 0) && !hasAsyncStorage) {
    return storeColMapper(defaultColumns);
  }

  if (storeColumns && storeColumns.length > 0) {
    const hasPaddingColumns = storeColumns.some(isPaddingColumn);

    if (hasPaddingColumns) {
      const realStoreColumns = storeColumns.filter((col) => !isPaddingColumn(col));
      const mergedColumns = mergeColumnsWithStore(realStoreColumns, defaultColumns);
      return storeColMapper(mergedColumns);
    }

    const newColumns = defaultColumns.filter(
      (gridCol) => !storeColumns.some((savedCol) => savedCol.field === gridCol.field),
    );

    if (newColumns.length > 0) {
      const mergedExisting = mergeColumnsWithStore(storeColumns, defaultColumns);
      const mergedColumns = [...mergedExisting, ...newColumns];
      return storeColMapper(mergedColumns);
    }
  }

  return null;
};
